import React, { useEffect } from "react";
import { GeneralTable, useModalAlert } from "../GeneralComponents";
import moment from "moment";

export function TableProveedores() {
  const [listproveedores, setListProveedores] = React.useState([]);
  const [listCountries, setListCountries] = React.useState([]);
  const [listDepartments, setListDepartments] = React.useState([]);
  const [listCities, setListCities] = React.useState([]);
  const [listTipoPersona, setListTipoPersona] = React.useState([]);
  const [listTipoContribuyente, setListTipoContribuyente] = React.useState([]);
  const [listListActEco, setListActEco] = React.useState([]);
  const [listTipoDocumentos, setListTipoDocumentos] = React.useState([]);
  const [listDocumentosConvocatoria, setListDocumentosConvocatoria] =
    React.useState([]);
  const [isEditMode, setIsEditMode] = React.useState(false);
  const { showModalAlert } = useModalAlert();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const [formData, setFormData] = React.useState({
    id_pais: 38,
    id_dpto: 26,
  });
  const pais = formData.id_pais;
  const id_dep = formData.id_dpto;
  const [listAllRegister, setListAllRegister] = React.useState(null);


  useEffect(() => {
    loadCountries();
    loadTipoPersona();
    loadTipoContibuyente();
    loadActividadesEconomicas();
    loadTiposDocumentos();
    loadDocumentosConvocatoria();
    loadTodosProveedores()
  }, []);

  useEffect(() => {
    loadProveedores();
  }, [page, pageSize]);

  useEffect(() => {
    if (pais) {
      loadDepartments();
    }
  }, [pais]);

  useEffect(() => {
    if (id_dep) {
      loadCities();
    }
  }, [id_dep]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
    setPage(0);
  };

  const loadTiposDocumentos = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-documento/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoDocumento = data.map((tipoDoc) => {
          return {
            value: tipoDoc.id,
            label: tipoDoc.nombre,
          };
        });
        setListTipoDocumentos(listaTipoDocumento);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadActividadesEconomicas = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "actividades-economicas/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaActividadesEconomicas = data.map((unidad) => {
          return {
            value: unidad.id,
            label: unidad.nombre,
            codigo: unidad.codigo,
          };
        });
        setListActEco(listaActividadesEconomicas);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDocumentosConvocatoria = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "documentos-convocatoria/listar",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaDocConvocatoria = data.map((documento) => {
          return {
            value: documento.id,
            label: documento.nombre,
          };
        });
        setListDocumentosConvocatoria(listaDocConvocatoria);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTipoContibuyente = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-contribuyente/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoContribuyente = data.map((unidad) => {
          return {
            value: unidad.id,
            label: unidad.nombre,
          };
        });
        setListTipoContribuyente(listaTipoContribuyente);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTipoPersona = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-persona/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoPersona = data.map((unidad) => {
          return {
            value: unidad.id,
            label: unidad.nombre,
          };
        });
        setListTipoPersona(listaTipoPersona);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadCountries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listCountries = data.map((pais) => {
          return {
            value: pais.id,
            label: pais.painom,
          };
        });
        setListCountries(listCountries);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDepartments = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "departamentos/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listDepartments = data.map((departamento) => {
          return {
            value: departamento.id,
            label: departamento.depnom,
          };
        });
        setListDepartments(listDepartments);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadCities = async () => {
    var data = { id_dep: id_dep };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("ciudades", data);
        const listCities = data.map((city) => {
          return {
            value: city.id,
            label: city.ciunom,
          };
        });
        setListCities(listCities);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadProveedores = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          `proveedores/listar?page=${page + 1}&page_size=${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setRowCount(data.count);

          const listProv = data.results.map((prov) => ({
            ...prov,
            id: prov.id,
          }));
          setListProveedores(listProv);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const loadTodosProveedores = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          `proveedores/listar`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {        
          setListAllRegister(data.results);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const consultarRegistro = async () => {
    const response = await fetch(
      process.env.REACT_APP_PUBLIC_URL + "proveedores/consultar",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    );
  };

  const onActivate = async (row) => {
    try {
      let dataSend = {
        id_proveedor: row.id,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "proveedores/activar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadProveedores();
      showModalAlert("success", "Se activo correctamente el proveedor");
    } catch {
      showModalAlert("danger", "Error al activar el proveedor");
      console.error("Error:", error);
    }
  };

  const onInactivate = async (row) => {
    try {
      let dataSend = {
        id_proveedor: row.id,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "proveedores/inactivar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadProveedores();
      showModalAlert("success", "Se inactivo correctamente el proveedor");
    } catch {
      showModalAlert("danger", "Error al inactivar el proveedor");
    }
  };

  const columns = [
    {
      field: "nombre_tipo_persona",
      headerName: "TIPO PERSONA",
      hide: true,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "nit",
      headerName: "NIT",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "razon_social",
      headerName: "RAZÓN SOCIAL",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "fecha_creacion",
      headerName: "FECHA CREACIÓN",
      hide: true,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("YYYY-MM-DD HH:mm:ss") : "",
    },
    {
      field: "nombre_tipo_contribuyente",
      headerName: "TIPO CONTRIBUYENTE",
      hide: true,
    },
    {
      field: "cod_ciiu_principal",
      headerName: "CÓDIGO CIIU PRINCIPAL",
      hide: true,
    },
    {
      field: "cod_ciiu_act_2",
      headerName: "CÓDIGO CIIU ACT 2",
      hide: true,
    },
    {
      field: "cod_ciiu_act_3",
      headerName: "CÓDIGO CIIU ACT 3",
      hide: true,
    },
    {
      field: "renta",
      headerName: "RENTA",
      hide: true,
      valueGetter: (params) => (params.value === true ? "Si" : "No"),
    },
    {
      field: "iva",
      headerName: "IVA",
      hide: true,
      valueGetter: (params) => (params.value === true ? "Si" : "No"),
    },
    {
      field: "nombre_pais",
      headerName: "PAIS",
      hide: true,
    },
    {
      field: "nombre_dpto",
      headerName: "DEPARTAMENTO",
      hide: true,
    },
    {
      field: "nombre_ciu",
      headerName: "CIUDAD",
      hide: true,
    },
    {
      field: "direccion",
      headerName: "DIRECCIÓN",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "celular",
      headerName: "CELULAR",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "email",
      headerName: "EMAIL",
      hide: true,
    },
    {
      field: "cod_tipo_documento",
      headerName: "TIPO DE DOC",
      hide: true,
    },
    {
      field: "numero_identificacion",
      headerName: "NUM DE DOC",
      hide: true,
    },
    {
      field: "nombre",
      headerName: "NOMBRE DEL REPRESENTANTE",
      hide: true,
    },
    {
      field: "cargo",
      headerName: "CARGO",
      hide: true,
    },
    {
      field: "celular_representante",
      headerName: "CELULAR DEL REPRESENTANTE",
      hide: true,
    },
    {
      field: "email_representante",
      headerName: "EMAIL DEL REPRESENTANTE",
      hide: true,
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const newModalField = [
    {
      name: "usuario",
      label: "Correo electrónico de usuario",
      type: "text",
      hidden: isEditMode,
    },
    {
      name: "password",
      label: "Contraseña",
      type: "password",
      hidden: isEditMode,
    },
    {
      name: "password2",
      label: "Confirma Contraseña",
      type: "password",
      hidden: isEditMode,
    },
    {
      name: "tipo_persona",
      label: "Tipo persona",
      type: "select",
      options: listTipoPersona,
    },
    {
      name: "nit",
      label: "Nit/Cédula de ciudadanía",
      type: "texto-disabled",
    },
    { name: "razon_social", label: "Razon social", type: "texto-disabled" },
    {
      name: "tipo_contribuyente",
      label: "Tipo de contribuyente",
      type: "select",
      options: listTipoContribuyente,
    },
    { type: "parrafo", label: "Sujecto de retención" },
    { name: "renta", label: "Renta", type: "radio" },
    { name: "iva", label: "IVA", type: "radio" },
    {
      name: "codigo_ciiu_principal",
      label: "Codigo CIIU principal",
      type: "autocomplete-texto",
      options: listListActEco,
    },
    {
      name: "codigo_ciiu_actividad2",
      label: "Codigo CIIU actividad 2",
      type: "autocomplete-texto",
      options: listListActEco,
    },
    {
      name: "codigo_ciiu_actividad3",
      label: "Codigo CIIU actividad 3",
      type: "autocomplete-texto",
      options: listListActEco,
    },
    {
      name: "codigo_ciiu_actividad4",
      label: "Codigo CIIU actividad 4",
      type: "autocomplete-texto",
      options: listListActEco,
    },
    {
      type: "label",
      label: "Datos de contacto del proveedor",
    },
    { name: "id_pais", label: "País", type: "select", options: listCountries },
    {
      name: "id_dpto",
      label: "Departamento",
      type: "select",
      options: listDepartments,
    },
    { name: "id_ciudad", label: "Ciudad", type: "select", options: listCities },
    {
      name: "direccion",
      label: "Dirección",
      type: "text",
    },
    {
      name: "celular",
      label: "Celular",
      type: "number",
    },
    {
      name: "email",
      label: "Correo electrónico",
      type: "email",
    },
    {
      type: "label",
      label: "Datos del representante legal ",
    },
    {
      name: "id_tipo_documento",
      label: "Tipo de documento",
      type: "select",
      options: listTipoDocumentos,
    },
    {
      name: "numero_identificacion",
      label: "Número de documento",
      type: "mayuscula",
    },
    {
      name: "nombre",
      label: "Nombre completo",
      type: "text",
    },
    {
      name: "cargo",
      label: "Cargo",
      type: "text",
    },
    {
      name: "celular_representante",
      label: "Celular",
      type: "number",
    },
    {
      name: "email_representante",
      label: "Correo electrónico",
      type: "email",
    },

    {
      type: "label",
      label: "Documentos requeridos",
    },
    {
      name: "documentos_convocatoria",
      type: "list-documentos",
      options: listDocumentosConvocatoria,
    },
  ];

  const requiredFields = [
    "tipo_persona",
    "nit",
    "razon_social",
    "tipo_contribuyente",
    "renta",
    "iva",
    "codigo_ciiu_principal",
    "codigo_ciiu_actividad2",
    "id_dpto",
    "id_pais",
    "id_ciudad",
    "direccion",
    "celular",
    "email",
    "id_tipo_documento",
    "numero_identificacion",
    "nombre",
    "cargo",
    "celular_representante",
    "email_representante",
  ];

  async function handleSave(formData, selectedFiles) {
    try {
      const dataToSend = new FormData();

      Object.keys(formData).forEach((key) => {
        dataToSend.append(key, formData[key]);
      });

      Object.keys(selectedFiles).forEach((documentType) => {
        dataToSend.append(documentType, selectedFiles[documentType]);
      });

      const url = isEditMode
        ? process.env.REACT_APP_PUBLIC_URL + "proveedores/update"
        : process.env.REACT_APP_PUBLIC_URL + "proveedores/create";

      const updateResponse = await fetch(url, {
        method: isEditMode ? "PUT" : "POST",
        headers: {
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: dataToSend,
      });

      if (!updateResponse.ok) {
        const errorData = await updateResponse.json();
        throw new Error(errorData.message || "Error en el servidor");
      }
      const result = await updateResponse.json();
      loadProveedores();
      setIsEditMode(false);
      if (isEditMode) {
        showModalAlert("success", "Se actualizó correctamente la proveedor");
      } else {
        showModalAlert("success", "Se creo correctamente la proveedor");
      }
    } catch (error) {
      console.log("error...", error);
      showModalAlert("danger", "Error al crear la proveedor");
    }
  }

  const onUpdate = (row) => {};

  return (
    <>
      <GeneralTable
        titleAlert="Proveedores"
        buttonText="Crear Proveedor"
        columns={columns}
        rows={listproveedores}
        modalFields={newModalField}
        rowCount={rowCount}
        page={page}
        pageSize={pageSize}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
        requiredFields={requiredFields}
        onSaveModal={handleSave}
        title=""
        consultarRegistro={consultarRegistro}
        onActivate={onActivate}
        onInactivate={onInactivate}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        enableUpdate
        onUpdate={onUpdate}
        enableView
        formData={formData}
        setFormData={setFormData}
        enableActivate
        width={"70%"}
        isModalRadication={true}
        loadList={loadProveedores}
        listAllRegister={listAllRegister}
        //isRadicacion={true}
      />
    </>
  );
}
